export const getBulkEventIdsKey = (eventIdsOrCodeUrls: number[] | string[]) => {
  return eventIdsOrCodeUrls.map((x) => String(x)).join('-')
}
